/**
 * 動態密碼驗證(註冊 / 重設密碼共用)。規則鏡射 fan pool 的
 * passwordPolicy(fan-cognito.ts:minLength 8 + 大寫 + 小寫 + 數字,
 * 不強制符號)。使用者一開始輸入就逐條顯示 ✓/✗,不必等送出被
 * Cognito 打回票才知道哪裡不合規;全部達標時收成一行綠色確認。
 */

export function passwordChecks(password: string): Array<{ ok: boolean; label: string }> {
  return [
    { ok: password.length >= 8, label: '至少 8 個字元' },
    { ok: /[A-Z]/.test(password), label: '至少 1 個大寫英文字母' },
    { ok: /[a-z]/.test(password), label: '至少 1 個小寫英文字母' },
    { ok: /\d/.test(password), label: '至少 1 個數字' },
  ];
}

export function passwordMeetsPolicy(password: string): boolean {
  return passwordChecks(password).every((c) => c.ok);
}

export function PasswordRuleHints({ password, id }: { password: string; id?: string }) {
  if (password.length === 0) return null;
  const checks = passwordChecks(password);
  if (checks.every((c) => c.ok)) {
    return <p id={id} className="mt-1.5 text-[11px] text-emerald-400">✓ 密碼符合要求</p>;
  }
  return (
    <ul id={id} aria-live="polite" className="mt-1.5 space-y-0.5 text-[11px]">
      {checks.map((c) => (
        <li key={c.label} className={c.ok ? 'text-emerald-400' : 'text-rose-300'}>
          {c.ok ? '✓' : '✗'} {c.label}
        </li>
      ))}
    </ul>
  );
}

/** 確認密碼欄的即時不一致提示。 */
export function PasswordMismatchHint({ password, confirm }: { password: string; confirm: string }) {
  if (confirm.length === 0 || password === confirm) return null;
  return <p aria-live="polite" className="mt-1.5 text-[11px] text-rose-300">✗ 兩次輸入的密碼不一致</p>;
}
